import { Pipe, PipeTransform } from '@angular/core';
import { BYTES_IN_KILOBYTE, BYTES_IN_MEGABYTE } from '../constants';

@Pipe({
  name: 'fileSize',
  standalone: true,
})
export class FileSizePipe implements PipeTransform {
  transform(bytes: number | null | undefined): string {
    if (bytes == null) {
      return '';
    }

    if (bytes < BYTES_IN_MEGABYTE) {
      return `${Math.max(1, Math.round(bytes / BYTES_IN_KILOBYTE))} KB`;
    }

    return `${(bytes / BYTES_IN_MEGABYTE).toFixed(1)} MB`;
  }
}
